import useB2BBasket from '@/b2b/basket/useBasket';
import basketStore from '@/shared/checkout/basket/basket.store';
import { computed } from 'vue';
import siteContextService from '@/b2b/shared/site-context.service';
import { AddOrUpdateModuleConfigurationRequest } from '../shared/api/server-apis';

const isNewCheckOutEnabled = computed(() => siteContextService.isNewCheckOutEnabled);
export default function useTEMPB2BFeatureBasket() {
    const {
        quantity,
        basketId,
        lineItems,
        pickAndPackDeliveryMaximumQuantity,
        init,
        get,
        addRegular,
        addPickAndPack,
        replaceItem,
        deleteItemBySku,
        addOrUpdateModuleConfiguration,
        getIsPickAndPack,
        setPickAndPackBySku,
    } = useB2BBasket();

    const basketInitByFeature = isNewCheckOutEnabled.value ? init : basketStore.init.bind(basketStore);
    const basketIdByFeature = computed(() => isNewCheckOutEnabled.value ? basketId.value : basketStore.basket.basketId);
    const basketQuantityByFeature = computed(() => isNewCheckOutEnabled.value ? quantity.value : basketStore.quantity);
    const pickAndPackDeliveryMaximumQuantityByFeature = computed(() => isNewCheckOutEnabled.value ? pickAndPackDeliveryMaximumQuantity.value : basketStore.basket.partnerExpressMaximumQuantity);
    const lineItemsByFeature = computed(() => {
        return isNewCheckOutEnabled.value ? lineItems.value : basketStore.lineItems;
    });

    const addRegularByFeature = async(sku: string, quantity: number, delta?: boolean, relatedItemId?: number) => {
        return isNewCheckOutEnabled.value ? await addRegular({ sku, quantity, relatedItemId, delta }) : await basketStore.addB2b(sku, quantity, delta);
    };

    const addPickAndPackByFeature = async(sku: string, quantity: number, delta?: boolean, relatedItemId?: number, messageId?: string) => {
        return isNewCheckOutEnabled.value ? await addPickAndPack({ sku, quantity, relatedItemId, delta }) : await basketStore.addB2bExpress(sku, quantity, false, messageId);
    };

    const replaceItemByFeature = async(lineItemId: string, targetSku: string) => {
        return isNewCheckOutEnabled.value ? await replaceItem({ lineItemId, targetSku }) : await basketStore.replaceItem(targetSku, lineItemId);
    };

    const deleteItemBySkuByFeature = async(sku: string, messageId?: string) => {
        return isNewCheckOutEnabled.value ? await deleteItemBySku(sku, messageId) : await basketStore.removeItem(sku);
    };

    const getByFeature = async() => {
        return isNewCheckOutEnabled.value ? await get() : await basketStore.get();
    };

    const addOrUpdateModuleConfigurationByFeature = async(configurationId: string, moduleConfiguratorTileData: AddOrUpdateModuleConfigurationRequest) => {
        return isNewCheckOutEnabled.value ? await addOrUpdateModuleConfiguration(configurationId, moduleConfiguratorTileData) : await basketStore.addOrUpdateModuleConfiguration(configurationId, moduleConfiguratorTileData);
    };

    const getIsPickAndPackByFeature = (item: any) => {
        if (!item) {
            return false;
        }
        return isNewCheckOutEnabled.value ? getIsPickAndPack(item.sku) : !!item.partnerExpressDeliverySelected;
    };

    const setPickAndPackBySkuByFeature = (sku: string, pickAndPack: boolean, messageId?: string) => {
        return isNewCheckOutEnabled.value ? setPickAndPackBySku(sku, pickAndPack, messageId) : basketStore.updateB2bExpress(sku, pickAndPack, messageId);
    };

    return {
        init: basketInitByFeature,
        basketId: basketIdByFeature,
        basketQuantity: basketQuantityByFeature,
        pickAndPackDeliveryMaximumQuantity: pickAndPackDeliveryMaximumQuantityByFeature,
        lineItems: lineItemsByFeature,
        addRegular: addRegularByFeature,
        addPickAndPack: addPickAndPackByFeature,
        replaceItem: replaceItemByFeature,
        deleteItemBySku: deleteItemBySkuByFeature,
        get: getByFeature,
        addOrUpdateModuleConfiguration: addOrUpdateModuleConfigurationByFeature,
        getIsPickAndPack: getIsPickAndPackByFeature,
        setPickAndPackBySku: setPickAndPackBySkuByFeature,
    };
}
